import { Component } from '@angular/core';
import { MediaPanelInfo } from '../../../../../models/datamodel/mediasource.model';
import { SettingsService } from '../../../../../services/settings.service';
import { BaseMediaSourcePanel } from '../basemediasource.panel';

@Component({
    selector: 'googledrive-panel',
    templateUrl: './googledrive.panel.html',
    styleUrls: ['./googledrive.panel.css']
})
export class GoogleDrivePanel extends BaseMediaSourcePanel {

    get RedirectUrl(): string {
        const ret = SettingsService.API_BASE_URL.getValue() + 'config/api/media/oauth/authorizegoogledrive';
        this.MediaSource.RedirectUrl = ret;
        this.MediaSource.Private = true; 
        return ret;
    }

    set RedirectUrl(val) {
        if (val != this.MediaSource.RedirectUrl) {
            this.MediaSource.RedirectUrl = val;
        }
    }

    authenticate(): void {
        const authstring = 'https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/drive&response_type=code&state=' + this.MediaSource.SID + '&redirect_uri=' + this.MediaSource.RedirectUrl + '&client_id=' + this.MediaSource.ClientId + '&access_type=offline&prompt=consent';
        window.open(authstring, '_blank');
    }

    static GetInfo(): MediaPanelInfo {
        return { 
            ControlType: GoogleDrivePanel,
            MediaType: '6e6d02bd-d96c-4f42-99d4-822f74d7f5e8'
        };
    }
}